import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface PreviewJobProposal {
  id: string;
  service_request_id: string;
  business_id: string;
  quote: number | null;
  status: string;
  response_message: string | null;
  created_at: string;
  service_request_title: string; // from service_requests.original_request
  business_name: string; // from businesses.name
  user_firstname: string;
  user_lastname: string;
}

export function usePreviewJobProposals(communityId?: string, enabled: boolean = true) {
  return useQuery({
    queryKey: ['preview-job-proposals', communityId],
    enabled: enabled && !!communityId,
    queryFn: async () => {
      if (!communityId) return [];

      const { data, error } = await supabase
        .from('job_proposals')
        .select(`
          id,
          service_request_id,
          business_id,
          quote,
          status,
          response_message,
          created_at,
          service_requests (
            original_request,
            user_profiles (
              firstname,
              lastname
            )
          ),
          businesses (
            name,
            community_id
          )
        `)
        .eq('businesses.community_id', communityId)
        .not('service_requests.user_profiles.firstname', 'is', null)
        .not('service_requests.user_profiles.lastname', 'is', null)
        .order('created_at', { ascending: false })
        .limit(10);

      if (error) {
        console.error('Error fetching preview job proposals:', error);
        throw error;
      }

      return (data || []).map((proposal: any) => ({
        id: proposal.id,
        service_request_id: proposal.service_request_id,
        business_id: proposal.business_id,
        quote: proposal.quote,
        status: proposal.status,
        response_message: proposal.response_message,
        created_at: proposal.created_at,
        service_request_title: proposal.service_requests?.original_request || '',
        business_name: proposal.businesses?.name || '',
        user_firstname: proposal.service_requests?.user_profiles?.firstname || '',
        user_lastname: proposal.service_requests?.user_profiles?.lastname || '',
      })) as PreviewJobProposal[];
    },
  });
}